import { React, useEffect, useState, useContext } from "react";
import WholeSalePriceData from "../../../Components/WholeSalePriceData";
import { MyContextProvider } from "../../../App";
import axios from "axios";
import { API_URL } from "../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import {
  shortMonthToFull,
  handleUserLevelAccessPermissions,
  getAllYears,
  validateRoles,
  validateMonthYears,
  shortMonthToMonthNumber,
} from "../../../Custom/Custom";
import messages from ".././../../assets/Messages.json";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import priceTitle from '../../../price.json';
import title from '../../../titles.json';

function WholeSalePrice() {
  const [districtList, setDistrictList] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState("");
  const [yearName, setYearName] = useState("");
  const [monthName, setMonthName] = useState("");
  const [wholeSalePrice, setWholeSalePrice] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision] = useState(false);
  const [isDistrict, setIsDistrict] = useState(false);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const storedLanguage = localStorage.getItem('language');

  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);

    // get District By Division ID
    const getDistrictListByDivision = async () => {
      try {
        const response = await axios.post(
          `${API_URL}api/geDistrictListByDivisionId`,
          { division_Id: decode_token.id.USER_LEVEL_LOCATION },
          config
        );
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    // All district list
    const getDistrictList = async () => {
      try {
        const response = await axios.get(
          `${API_URL}api/getallDistrictList`,
          config
        );
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    // Set district list for district-level user
    const setDistrictForDistrictLevel = () => {
      const districtCode = decode_token.id.USER_LEVEL_LOCATION;
      const districtName = decode_token.id.LOCATION_NAME;

      const singleDistrict = [
        {
          DISTRICT_CODE: districtCode,
          DISTRICT_NAME: districtName,
        },
      ];

      setDistrictList(singleDistrict);
      setDistrictCode(districtCode);
      setIsDistrict(true);
      handleDistrictChange(districtCode);
      showLoading(false);
    };

    //Get all Months data
    const getMonthsList = (e) => {
      showLoading(true);
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    };

    const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRoles(decode_token);
        if (role) {
          getYearList();
          getMonthsList();

          if (
            level.userLevel === "DIVISION LEVEL" &&
            level.roles.includes("DIVADM")
          ) {
            getDistrictListByDivision();
            setIsDivision(true);
          } else if (level.userLevel === "DISTRICT LEVEL") {
            setDistrictForDistrictLevel();
          } else {
            getDistrictList();
          }
        } else {
          alert(
            "You are not an authorized user to capture the data for Pricing"
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    userRole();
  }, []);

  const handleDistrictChange = (districtId) => {
    showLoading(true);
    axios
      .post(
        `${API_URL}api/consumerRetail/getwholeSalePriceInputForm`,
        {
          district_code: districtId,
        },
        config
      )
      .then((response) => {
        const { data, status } = response.data;

        if (status) {
          if (data[0].GroupCodes.length === 0) {
            toast.error(response.data.message, messages.COLOR_RED);
          }
          setWholeSalePrice(data[0].GroupCodes);
        }
        setTimeout(() => showLoading(false), 3000);
      })
      .catch((error) => {
        console.error("Error fetching district data:", error);
        showLoading(false);
      });
  };

  const handleDropdownChange = (e) => {
    switch (e.target.name) {
      case "district_name":
        setDistrictCode(e.target.value);
        handleDistrictChange(e.target.value);
        setMonthName("");
        setYearName("");
        break;
      case "month_name":
        setMonthName(e.target.value);
        setYearName("");
        break;
      case "year_name":
        if (districtCode === "") {
          toast.error(messages.DISTRICT_MSG, messages.COLOR_RED);
          setYearName("");
          return;
        }

        if (monthName === "") {
          toast.error(messages.MONTH_MSG, messages.COLOR_RED);
          setYearName("");
          return;
        }

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const selectedYear = parseInt(e.target.value);
        const selectedMonth = parseInt(shortMonthToMonthNumber(monthName)); 

        if (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth > currentMonth)) {
          toast.error('Invalid Month Selection.', messages.COLOR_RED);
          setMonthName("");
          setYearName("");
          return; 
        }

        setYearName(e.target.value);
        let postData = {
          district_code: districtCode,
          month_name: shortMonthToMonthNumber(monthName),
          year_name: e.target.value,
        };
        onChangeWholeSalePrice(postData);

        break;
      default:
        console.log("switch case are not match");
        break;
    }
  };

  const onChangeWholeSalePrice = async (postData) => {
    showLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}api/consumerRetail/getwholeSalePriceInputFormWithData`,
        postData,
        config
      );
      if (response.data.status && response.data.data && response.data.data[0] && response.data.data[0].GroupCodes && response.data.data[0].GroupCodes[0]) {
        setWholeSalePrice(response.data.data[0].GroupCodes[0]);
        setPayload(response.data.data[1]?.payload || []);
        showLoading(false);
      } else {
        setWholeSalePrice([]);
        setPayload([]);
        toast.error('Data not found', messages.COLOR_RED);
        showLoading(false);
      }
    } catch (error) {
      setWholeSalePrice([]);
      setPayload([]);
      toast.error('Data not found', messages.COLOR_RED);
      console.error('Error posting data:', error);
      showLoading(false);
    }
  };

  const resetMothAndYearField = () => {
    setMonthName("");
    setYearName("");
    if (!isDistrict) {
      setDistrictCode("");
    }
    setWholeSalePrice([]);
  };

  const showMessagewhole = () =>{
 toast.error("Please select district, month, year", messages.COLOR_RED);

  }

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WHOLE_SALE_PRICE : priceTitle.en.WHOLE_SALE_PRICE }} />
              </h4>

              <div className="row align-items-center">
                {isDivision && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label> 
                      {storedLanguage === 'hi' ? title.hi.DIVISION : title.en.DIVISION}
                      
                       </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={decode_token.id.LOCATION_NAME}
                    />
                  </div>
                )}
                {isDistrict && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>
                      {storedLanguage === 'hi' ? title.hi.DISTRICT : title.en.DISTRICT}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={decode_token.id.LOCATION_NAME}
                    />
                  </div>
                )}
                {!isDistrict && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label>
                    {storedLanguage === 'hi' ? title.hi.DISTRICT : title.en.DISTRICT}
                     </label>
                    <select
                      name="district_name"
                      id="district_name"
                      className="form-select"
                      onChange={handleDropdownChange}
                      value={districtCode}
                    >
                      <option value="" disabled>
                        Select District
                      </option>
                      {districtList &&
                        districtList
                          .slice()
                          .sort((a, b) =>
                            a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME)
                          )
                          .map((ele, index) => (
                            <option key={index} value={ele.DISTRICT_CODE}>
                              {ele.DISTRICT_NAME}
                            </option>
                          ))}
                    </select>
                  </div>
                )}

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>
                  {storedLanguage === 'hi' ? title.hi.MONTH : title.en.MONTH}
                  </label>
                  <select
                    name="month_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={monthName}
                  >
                    <option value="" disabled>
                      Select Month
                    </option>
                    {months &&
                      months.map((ele, i) => (
                        <option key={i} value={ele.MONTH}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>
                  {storedLanguage === 'hi' ? title.hi.CURRENT_YEAR : title.en.CURRENT_YEAR}
                    </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-3 mb-3">
          {wholeSalePrice.length > 0 ? (
            <WholeSalePriceData
              type="wholeSale"
              payload={payload}
              districtCode={districtCode}
              config={config}
              resetMothAndYearField={resetMothAndYearField}
              userInfoObject={buttonAccess}
              yearName={yearName}
              monthName={monthName}
              wholeSalePrice={wholeSalePrice}
              url="/consumerRetail/WholeSalePriceInputFormDataSaveToDB"
            />
          ) : (
           
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th rowSpan="2"> {storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.ITEM_NAME : priceTitle.en.ITEM_NAME}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.VARITY_NAME : priceTitle.en.VARITY_NAME}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.UNITE : priceTitle.en.UNITE}</th>
                        <th colSpan="5">{storedLanguage === 'hi' ? priceTitle.hi.MONTHLY_FRIDAY : priceTitle.en.MONTHLY_FRIDAY}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.AVERAGE : priceTitle.en.AVERAGE}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.REMARK : priceTitle.en.REMARK}</th>
                        <th rowSpan="2">REJECT STATUS</th>
                      </tr>
                      <tr>
                        <th>{storedLanguage === 'hi' ? priceTitle.hi.FIRST_FRIDAY : priceTitle.en.FIRST_FRIDAY}</th>
                        <th>{storedLanguage === 'hi' ? priceTitle.hi.SECOND_FRIDAY : priceTitle.en.SECOND_FRIDAY}</th>
                        <th>{storedLanguage === 'hi' ? priceTitle.hi.THIRD_FRIDAY : priceTitle.en.THIRD_FRIDAY}</th>
                        <th>{storedLanguage === 'hi' ? priceTitle.hi.FOURTH_FRIDAY : priceTitle.en.FOURTH_FRIDAY}</th>
                        <th>{storedLanguage === 'hi' ? priceTitle.hi.FIFTH_FRIDAY : priceTitle.en.FIFTH_FRIDAY}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <input
                            type="text"
                            id="itemName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            id="itemVarietyName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            id="itemUnitName0"
                            disabled
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="firstFriday0"
                            id="firstFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="secondFriday0"
                            id="secondFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="thirdFriday0"
                            id="thirdFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="fourthFriday0"
                            id="fourthFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="fifthFriday0"
                            id="fifthFriday0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="controlledPrice0"
                            id="controlledPrice0"
                            className="form-control"
                            defaultValue=""
                          />
                        </td>
                        <td className="grid-row">
                          <select
                            name="remark0"
                            id="remark0"
                            className="form-select"
                            defaultValue=""
                          >
                            <option value="">[---Select---]</option>
                            {
                                buttonAccess.userLevel === "HEAD QUARTER" ?
                                  <><option value="Price is Too Low">Price is Too Low</option>
                                    <option value="Price is too High">Price is too High</option>
                                    <option value="Price does not match with unit">Price does not match with unit</option>
                                    <option value="Price does not match with variety">Price does not match with variety</option>
                                    <option value="Other.">Other.</option>
                                  </>
                                  :
                                  <><option value="Production is low">Production is low</option>
                                    <option value="Production is high">Production is high</option>
                                    <option value="Less supply">Less supply</option>
                                    <option value="Not Available">Not Available</option>
                                    <option value="On sale">On sale</option>
                                    <option value="Seasonal effect">Seasonal effect</option>
                                    <option value="Discounted Item">Discounted Item</option>
                                    <option value="Other">Other</option>
                                  </>
                              }
                          </select>
                        </td>
                        <td colSpan="1">
                          <input type="checkbox" name="status0" id="status0" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
             
              <div className="row">
                <div className="col-12 text-center pt-3">
                  <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                    Save
                  </button>
                  <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                    Accept
                  </button>
                  <button type="button" className="btn btn_orange mx-1" onClick={(e)=>(showMessagewhole())}>
                    Reject
                  </button>
                  <button type="reset" className="btn btn_orange mx-1">
                    Reset
                  </button>
                  <button 
                    type="button" 
                    className="btn btn_orange mx-1" 
                    onClick={(e)=>( navigate("/dashboard"))} 
                    >
                  Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default WholeSalePrice;
